import { useGetTrackerParams } from './useGetTrackerParams';

import {
  initTracker,
  trackWidgetShow,
  trackWidgetSearchParamsChange,
  trackWidgetError,
  WidgetErrorType,
  convertCigaretteParamsForTracking,
} from '../../../utils/tracker';

import { WidgetName } from '../../../models';
import type { Values } from '../../../components/Cigarette/context';

export type TrackerMethods = {
  trackShow: (customShowParams?: Partial<CustomShowParams>) => void;
  trackSearchParamsChange: (changedParams: Partial<Values>, newSearchParams: Values) => void;
  trackError: (errorType: WidgetErrorType) => void;
};

export type CustomShowParams = {
  results_size: number;
  price: number;
  hotel_id: number;
  search_params: any;
};

export const useTracker = (
  widgetNameParam?: WidgetName,
  whitelabelNameParam?: string
): TrackerMethods | undefined => {
  const { isTrackingEnabled, widgetName, ...trackerParams } = useGetTrackerParams(
    widgetNameParam,
    whitelabelNameParam
  );

  if (!isTrackingEnabled || !widgetName) {
    return;
  }

  initTracker();

  const trackShow = (customShowParams?: Partial<CustomShowParams>) => {
    trackWidgetShow({ ...trackerParams, widgetName, customShowParams });
  };

  const trackSearchParamsChange = (changedParams: Partial<Values>, newSearchParams: Values) => {
    const newConvertedParams = convertCigaretteParamsForTracking(newSearchParams);
    const searchParams = { ...trackerParams.searchParams, ...newConvertedParams };

    trackWidgetSearchParamsChange({
      ...trackerParams,
      widgetName,
      changedParams,
      searchParams,
    });
  };

  const trackError = (errorType: WidgetErrorType) => {
    trackWidgetError({ ...trackerParams, widgetName, errorType });
  };

  return { trackShow, trackSearchParamsChange, trackError };
};
